import type { Run, RunPhase } from './run'

export class HUD {
  private timerEl: HTMLElement
  private speedEl: HTMLElement
  private statusEl: HTMLElement
  private lastPhase: RunPhase = 'idle'

  constructor() {
    this.timerEl = document.getElementById('timer')!
    this.speedEl = document.getElementById('speed')!
    this.statusEl = document.getElementById('status')!
  }

  update(run: Run, nowSec: number, speed: number): void {
    const phase = run.state.phase
    if (phase !== this.lastPhase) {
      if (phase === 'finished') {
        this.timerEl.classList.add('finished')
        this.statusEl.textContent = 'finished — press R to retry'
      } else {
        this.timerEl.classList.remove('finished')
        this.statusEl.textContent = ''
      }
      this.lastPhase = phase
    }
    this.timerEl.textContent = formatTime(run.elapsed(nowSec))
    this.speedEl.textContent = `${Math.round(speed)} u/s`
  }
}

function formatTime(sec: number): string {
  if (sec < 0) sec = 0
  const ms = Math.floor(sec * 1000)
  const mm = Math.floor(ms / 60000)
  const ss = Math.floor((ms % 60000) / 1000)
  const cc = Math.floor((ms % 1000) / 10)
  return `${pad2(mm)}:${pad2(ss)}.${pad2(cc)}`
}

function pad2(n: number): string {
  return n < 10 ? `0${n}` : String(n)
}
